module.exports = __webpack_public_path__ + "static/media/portfolio-01 copy.368bfa5f.jpg";